import {Link, useLocation} from "react-router-dom";
import React, {useRef, useState} from "react";
import {useTranslation} from "../../i18n/translation";
import {useTheme} from "./Header";
import "../../css/headerNavMenu.css";

export default function HeaderMenu({menuLinks, classes, setSearchState}) {

    const location = useLocation();
    const {t} = useTranslation();
    const [activeMegaMenu, setActiveMegaMenu] = useState(null);
    const [hoverState, setHoverState] = useState({});
    const navItemRefs = useRef({});
    const megaMenuRef = useRef(null);
    const hoverTimeoutRef = useRef(null); // Таймер для плавного перехода
    const {theme} = useTheme()

    // Управление состоянием мега-меню
    const handleMegaMenuToggle = (path) => {
        setSearchState(false)
        setActiveMegaMenu(activeMegaMenu === path ? null : path);
    };

    // Рекурсивная функция для обычного выпадающего меню
    const renderNestedMenu = (links, basePath = '', level = 0) => {
        const items = Object.entries(links);
        const maxItems = 10; // Максимальное количество элементов


        return items.slice(0, maxItems).map(([key, item]) => {
            const fullPath = `${basePath}/${key}`;

            return (
                <div
                    key={fullPath}
                    className={`menu-item-container ${theme} level-${level}`}
                    onMouseEnter={() => setHoverState(prev => ({...prev, [fullPath]: true}))}
                    onMouseLeave={() => setHoverState(prev => ({...prev, [fullPath]: false}))}
                >
                    <Link
                        to={fullPath}
                        onClick={() => {
                            setHoverState({});
                            setSearchState(false);
                            setActiveMegaMenu(null);
                        }}
                        className={`menu-link ${level > 0 ? 'submenu-link' : ''}`}
                    >
                        {item.title}
                    </Link>
                </div>
            );
        });
    };

    // Рендер колонок для мега-меню
    const renderMegaMenuColumns = (links) => {
        // В мега-меню бывает не просто разместить объекты, чтобы не менять каждый раз порядок в JSON структуре
        // порядок для меню будет задан здесь, также по необходимости какие-то разделы можно исключить для меню
        let manual_sorting = ["machines", "cranes", "bridges", "parts",  "axles", "tankContainers",    "capacities", "mobileSystems"]
        return manual_sorting.map(key => {
            const category = links[key];
            return [key, category];
        }).map(([key, category]) => {
            const hasSubcategories = category.links && Object.keys(category.links).length > 0;
            const categoryPath = `/${activeMegaMenu}/${key}`;
            const isCategoryActive = location.pathname === categoryPath;

            return (
                <div key={key} className="mega-menu-column">
                    <Link
                        to={categoryPath}
                        onClick={() => {
                            setSearchState(false);
                            setActiveMegaMenu(null)
                        }}
                        className={`${category.type === "product" ? "mega-menu-product-link" : "mega-menu-column-title"} ${isCategoryActive ? "openedLink" : ""}`}
                    >
                        <h3>{category.title}</h3>
                    </Link>

                    {hasSubcategories && (
                        <div className="mega-menu-subcategory">
                            {Object.entries(category.links).map(([subKey, subcategory]) => {
                                const hasSubSubcategories = subcategory.links && Object.keys(subcategory.links).length > 0;
                                const maxItems = 3; // Максимум 3 элемента
                                const showAllThreshold = 4; // Порог для кнопки "Показать все"

                                const subcategoryPath = `${categoryPath}/${subKey}`;
                                const isSubcategoryActive = location.pathname === subcategoryPath;

                                // Проверяем, нужно ли показывать кнопку "Показать все"
                                const shouldShowAllLink =
                                    hasSubSubcategories &&
                                    Object.keys(subcategory.links).length > showAllThreshold;

                                return (
                                    subcategory.type === "menu" ? (
                                        <div key={subKey} className="mega-menu-subcategory">
                                            <Link
                                                to={subcategoryPath}
                                                onClick={() => {
                                                    setSearchState(false);
                                                    setActiveMegaMenu(null)
                                                }}
                                                className={`mega-menu-subcategory-title ${isSubcategoryActive ? "openedLink" : ""}`}
                                            >
                                                {subcategory.title}
                                            </Link>

                                            {hasSubSubcategories && (
                                                <div className="mega-menu-subsubcategories">
                                                    {Object.entries(subcategory.links)
                                                        .slice(0, shouldShowAllLink ? maxItems : undefined)
                                                        .map(([subSubKey, subsubcategory]) => {
                                                            const hasProducts = subsubcategory.links && Object.keys(subsubcategory.links).length > 0;
                                                            const subsubcategoryPath = `${subcategoryPath}/${subSubKey}`;
                                                            const isSubsubcategoryActive = location.pathname === subsubcategoryPath;

                                                            return subsubcategory.type === "menu" ? (
                                                                <div key={subSubKey}
                                                                     className="mega-menu-subsubcategory">
                                                                    <Link
                                                                        to={subsubcategoryPath}
                                                                        onClick={() => {
                                                                            setSearchState(false);
                                                                            setActiveMegaMenu(null)
                                                                        }}
                                                                        className={`mega-menu-subsubcategory-title ${isSubsubcategoryActive ? "openedLink" : ""}`}
                                                                    >
                                                                        {subsubcategory.title}
                                                                    </Link>

                                                                    {hasProducts && (
                                                                        <ul className="mega-menu-products">
                                                                            {Object.entries(subsubcategory.links)
                                                                                .slice(0, maxItems)
                                                                                .map(([productKey, product]) => {
                                                                                    const productPath = `${subsubcategoryPath}/${productKey}`;
                                                                                    return (
                                                                                        <li key={productKey}>
                                                                                            <Link
                                                                                                to={productPath}
                                                                                                onClick={() => {
                                                                                                    setSearchState(false);
                                                                                                    setActiveMegaMenu(null)
                                                                                                }}
                                                                                                className={`mega-menu-product-link ${location.pathname === productPath ? "openedLink" : ""}`}
                                                                                            >
                                                                                                {product.title}
                                                                                            </Link>
                                                                                        </li>
                                                                                    );
                                                                                })}

                                                                            {/* Кнопка "Показать все" для продуктов */}
                                                                            {Object.keys(subsubcategory.links).length > maxItems && (
                                                                                <li>
                                                                                    <Link
                                                                                        to={subsubcategoryPath}
                                                                                        onClick={() => {
                                                                                            setSearchState(false);
                                                                                            setActiveMegaMenu(null)
                                                                                        }}
                                                                                        className="mega-menu-view-all"
                                                                                    >
                                                                                        {t("Показать все →")}
                                                                                    </Link>
                                                                                </li>
                                                                            )}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <Link
                                                                    key={subSubKey}
                                                                    to={subsubcategoryPath}
                                                                    onClick={() => {
                                                                        setSearchState(false);
                                                                        setActiveMegaMenu(null)
                                                                    }}
                                                                    className={`mega-menu-product-link ${isSubsubcategoryActive ? "openedLink" : ""}`}
                                                                >
                                                                    {subsubcategory.title}
                                                                </Link>
                                                            );
                                                        })}

                                                    {/* Кнопка "Показать все" для меню */}
                                                    {shouldShowAllLink && (
                                                        <Link
                                                            to={subcategoryPath}
                                                            onClick={() => {
                                                                setSearchState(false);
                                                                setActiveMegaMenu(null)
                                                            }}
                                                            className="mega-menu-view-all"
                                                        >
                                                            {t("Показать все →")}
                                                        </Link>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <Link
                                            key={subKey}
                                            to={subcategoryPath}
                                            onClick={() => {
                                                setSearchState(false);
                                                setActiveMegaMenu(null)
                                            }}
                                            className={`mega-menu-product-link ${isSubcategoryActive ? "openedLink" : ""}`}
                                        >
                                            {subcategory.title}
                                        </Link>
                                    )
                                );
                            })}
                        </div>
                    )}
                </div>
                );
        });
    };

        return (
            <>
                <nav className={`${classes.navMenu}`}>
                    {menuLinks.map(({path, label, links, hasMegaMenu}) => {
                        const isActive = location.pathname.includes(path);
                        const hasChildren = links && Object.keys(links).length > 0;

                        // Внешние ссылки
                        if (path.startsWith('http')) {
                            return (
                                <div key={path} className="nav-item"
                                     onMouseEnter={() => setActiveMegaMenu(null)}>
                                    <a
                                        href={path}
                                        className={`menu-button ${isActive ? 'active' : ''}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {label}
                                    </a>
                                </div>
                            );
                        }

                        // Пункты меню с мега-меню
                        if (hasMegaMenu) {
                            return (
                                <div
                                    key={path}
                                    className="nav-item has-mega-menu"
                                    ref={el => navItemRefs.current[path] = el}
                                    onMouseEnter={() => {
                                        clearTimeout(hoverTimeoutRef.current);
                                        setActiveMegaMenu(path);
                                    }}
                                    onMouseLeave={() => {
                                        // Задержка для плавного перехода
                                        hoverTimeoutRef.current = setTimeout(() => {
                                            setActiveMegaMenu(null);
                                        }, 300);
                                    }}
                                >
                                    <Link
                                        to={`/${path.replace(/^\/+/, '')}`}
                                        className={`menu-button ${isActive || activeMegaMenu === path ? 'active' : ''}`}
                                        onClick={() => handleMegaMenuToggle(path)}
                                    >
                                        {label}
                                        <span className="dropdown-indicator"> </span>
                                    </Link>
                                </div>
                            );
                        }

                        // Пункты меню с обычным выпадающим меню
                        return (
                            <div
                                key={path}
                                className="nav-item"
                                onMouseEnter={() => {
                                    setActiveMegaMenu(null);
                                    setHoverState(prev => ({...prev, [path]: true}));
                                }}
                                onMouseLeave={() => setHoverState(prev => ({...prev, [path]: false}))}
                            >
                                <Link
                                    to={`/${path.replace(/^\/+/, '')}`}
                                    onClick={() => {
                                        setSearchState(false);
                                        setActiveMegaMenu(null);
                                    }}
                                    className={`menu-button ${isActive ? 'active' : ''}`}
                                >
                                    {label}
                                    {hasChildren && <span className="dropdown-indicator"> </span>}
                                </Link>

                                {/* Обычное выпадающее меню */}
                                {hasChildren && hoverState[path] && (
                                    <div className={`dropdown-menu level-0 ${theme}`}>
                                        {renderNestedMenu(links, path, 0)}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </nav>

                {/* Мега-меню */}
                {activeMegaMenu && (
                    <div
                        className={`mega-menu ${theme}`}
                        ref={megaMenuRef}
                        onMouseEnter={() => clearTimeout(hoverTimeoutRef.current)}
                        onMouseLeave={() => {
                            hoverTimeoutRef.current = setTimeout(() => {
                                setActiveMegaMenu(null);
                            }, 300);
                        }}
                    >
                        <div className="mega-menu-inner">
                            {menuLinks
                                .filter(item => item.path === activeMegaMenu)
                                .map(item => (
                                    item.links && renderMegaMenuColumns(item.links)
                                ))
                            }
                        </div>
                    </div>
                )}
            </>
        );
    }